import script from "./ResearchToolsEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResearchToolsEditor.vue?vue&type=script&setup=true&lang=ts"

import "./ResearchToolsEditor.vue?vue&type=style&index=0&id=bfe67f48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfe67f48"]])

export default __exports__